export default "__VITE_ASSET__a8704b4e__"